"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Icon = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./index.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Icon = function Icon(_ref) {
  var type = _ref.type,
      style = _ref.style,
      className = _ref.className,
      id = _ref.id,
      weight = _ref.weight,
      strokeColor = _ref.strokeColor;
  var weightStyle = {};

  switch (weight) {
    case 'bold':
      weightStyle = {
        webkitTextStroke: "1px ".concat(strokeColor)
      };
      break;

    case 'med':
      weightStyle = {
        webkitTextStroke: "0.5px ".concat(strokeColor)
      };
      break;

    default:
      break;
  }

  var propsStyle = _objectSpread(_objectSpread({}, weightStyle), style);

  return /*#__PURE__*/_react.default.createElement("i", {
    id: id,
    className: "shpmtc-icon ".concat(type, " ").concat(className),
    style: propsStyle
  });
}; // Prop Types


exports.Icon = Icon;
Icon.defaultProps = {
  type: null,
  style: null,
  className: '',
  id: null,
  weight: null,
  strokeColor: '#111'
};
Icon.propTypes = {
  type: _propTypes.default.string,
  style: _propTypes.default.instanceOf(Object),
  className: _propTypes.default.string,
  id: _propTypes.default.string,
  weight: _propTypes.default.oneOf(['bold', 'med']),
  strokeColor: _propTypes.default.string
};